var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.deliveryFeeMsg && _vm.cart.shippingAddress.deliveryServiceId === 2)?_c('div',{staticClass:"subtitle-2 delivery-fee"},[_vm._v(" "+_vm._s(_vm.deliveryFeeMsg)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }